
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'

import ReadAggrement from '@/page/supplier/register/read-aggrement'
import SuppleInfor from '@/page/supplier/register/supple-infor'
import VerifyCompany from '@/page/supplier/register/verify-company'
import RegisterBegin from '@/page/supplier/register/register-begin'
import SendEmail from '@/page/supplier/register/send-email'
import EmailSuccess from '@/page/supplier/register/email-success'
export default {
name: "register",
components:{
Step,
StepItem,
ReadAggrement,
SuppleInfor,
VerifyCompany,
RegisterBegin,
SendEmail,
EmailSuccess
},
data(){
return{
step:0,
verifyObj:{},
type:'new',
email:null,
supplier:null,
phone:null
}
},
methods:{
toTop() {
document.documentElement.scrollTop = document.body.scrollTop = 0;
},
changeStep(data,obj){
if(obj){
this.verifyObj = obj;
this.supplier = this.verifyObj.supplierName;
}
this.step = data;
this.toTop();
if(this.step == 0){
this.type = 'new';
}
if(this.step == 3){
this.$refs.suppleInfor.dataRefresh();
}
},
msgSuccess(email,supplier,mobilePhone){
this.email = email;
if(supplier){
this.supplier = supplier;
}
if(mobilePhone){
this.phone = mobilePhone;
}
if(this.type === 'reset'){
this.toTop();
this.step = 2;
}else{
this.toTop();
this.step = 4;
}
},
selectRegister(e){
this.step = 1;
this.toTop();
this.type = e;
if(e === 'reset'){
setTimeout(() => {
this.$refs.sendEmail.refreshImageCode();
},0);
}
},

backLastPage(){
if(this.$store.state.device === 'wap'){
this.$router.go(-1);
}else{
document.location = "http://action:10002/?";
}
}
},
mounted(){
if(this.$route.query.inviteCheckKey){
this.$get(`api/sup-invite/get-by-check-key?inviteCheckKey=${this.$route.query.inviteCheckKey}`).then((res) => {
if(res){
this.$eventHub.$emit('sendInviteInfo',res);
}
})
}
},

}



// WEBPACK FOOTER //
// ./src/page/supplier/register/register.vue